'use client'

import classNames from 'clsx'
import { ComponentPropsWithoutRef, forwardRef } from 'react'

import S from '../Table.module.scss'

export interface TableHeaderCellProps extends ComponentPropsWithoutRef<'th'> {
  align?: 'left' | 'center' | 'right'
}

export const TableHeaderCell = forwardRef<
  HTMLTableCellElement,
  TableHeaderCellProps
>(({ className, children, align = 'center', ...props }, ref) => {
  return (
    <th
      {...props}
      ref={ref}
      className={classNames(S.headerCell, S[`align-${align}`], className)}
    >
      {children}
    </th>
  )
})

TableHeaderCell.displayName = 'Table.HeaderCell'

export interface TableCellProps extends ComponentPropsWithoutRef<'td'> {
  align?: 'left' | 'center' | 'right'
}

export const TableCell = forwardRef<HTMLTableCellElement, TableCellProps>(
  ({ className, children, align = 'center', ...props }, ref) => {
    return (
      <td
        {...props}
        ref={ref}
        className={classNames(S.cell, S[`align-${align}`], className)}
      >
        {children}
      </td>
    )
  }
)

TableCell.displayName = 'Table.Cell'
